import { isEmpty, map, noop } from 'lodash'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import StepItem, { TStep, TStepItem } from './StepItem'

const StepBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  &.vertical {
    flex-direction: column;
    max-width: 50px;
  }
`

export interface TSteppingBar extends TStepItem {
  steps?: TStep[]
  /* type of direction horizontal or vertical */
  vertical?: boolean
  disableVertical?: boolean
}

const SteppingBar = (props: TSteppingBar): React.ReactElement => {
  const {
    steps = [],
    vertical = false,
    disableVertical = false,
    color = '#5cb85c',
    onChange = noop,
    disableSkip = false,
    validateStep = noop,
    textColor = '',
    disabledClick = false,
    disableNext = false,
  } = props
  const [current, setCurrent] = useState(props.current || 0)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 760)

  useEffect(() => {
    const resize = (): void => {
      const renderMobile = window.innerWidth < 768 || false
      setIsMobile(renderMobile)
    }

    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  const onChangeLocal = (val: number): void => {
    if (!isEmpty(validateStep(val))) {
      return
    }
    setCurrent(val)
    onChange(val)
  }

  useEffect(() => {
    if (props.current) {
      onChangeLocal(props.current)
    }
  }, [props.current])

  const sortedSteps = steps.sort((a: any, b: any) => {
    return a.position - b.position
  })

  return (
    <>
      <StepBar
        className={`stepbar__container ${
          !disableVertical && (vertical || isMobile) ? 'vertical' : ''
        }`}
      >
        {map(sortedSteps, (step, index: number) => (
          <StepItem
            key={index}
            color={color}
            current={current}
            index={index}
            onClick={onChangeLocal}
            step={step}
            disabledClick={disabledClick}
            disableSkip={disableSkip}
            disableNext={disableNext}
            textColor={textColor}
          />
        ))}
      </StepBar>
    </>
  )
}

export default SteppingBar
